import { render, staticRenderFns } from "./shop_type.vue?vue&type=template&id=5339b359"
import script from "./shop_type.vue?vue&type=script&lang=js"
export * from "./shop_type.vue?vue&type=script&lang=js"
import style0 from "./shop_type.vue?vue&type=style&index=0&id=5339b359&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports